import { createStandardAction } from "typesafe-actions";

export const saveDeliveries = createStandardAction("@@utils/SAVE_DASHBOARD_DELIVERIES")();
export const saveUpdateAt = createStandardAction("@@utils/SAVE_DASHBOARD_UPDATE_AT")();
export const savePawns = createStandardAction("@@utils/SAVE_DASHBOARD_PAWNS")();
export const savePackingList = createStandardAction("@@utils/SAVE_DASHBOARD_PACKING_LIST")();

export const saveTradingTypesValues = createStandardAction("@@utils/SAVE_DASHBOARD_TRADINGTYPESVALUES")();